export const BRAZIL_DATE_FORMAT = "dd/MM/yyyy";

const pad = (value) => String(value).padStart(2, "0");

const isValidDate = (value) =>
  value instanceof Date && !Number.isNaN(value.getTime());

const formatParts = (year, month, day, hour, minute) => {
  const date = `${pad(day)}/${pad(month)}/${year}`;

  if (hour === undefined || minute === undefined) {
    return date;
  }

  return `${date} ${pad(hour)}:${pad(minute)}`;
};

const hasUsefulTime = (hour, minute, second) =>
  Number(hour || 0) !== 0 || Number(minute || 0) !== 0 || Number(second || 0) !== 0;

export function formatDateToBrazil(value) {
  if (value === null || value === undefined || value === "") {
    return value;
  }

  if (isValidDate(value)) {
    const hour = value.getHours();
    const minute = value.getMinutes();
    const second = value.getSeconds();

    return hasUsefulTime(hour, minute, second)
      ? formatParts(value.getFullYear(), value.getMonth() + 1, value.getDate(), hour, minute)
      : formatParts(value.getFullYear(), value.getMonth() + 1, value.getDate());
  }

  if (typeof value !== "string") {
    return value;
  }

  const trimmed = value.trim();

  const isoMatch = trimmed.match(
    /^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2})(?::(\d{2}))?)?/
  );
  if (isoMatch) {
    const [, year, month, day, hour, minute, second] = isoMatch;

    return hour !== undefined && hasUsefulTime(hour, minute, second)
      ? formatParts(year, month, day, hour, minute)
      : formatParts(year, month, day);
  }

  const slashMatch = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:\s+(\d{1,2}):(\d{2}))?$/);
  if (slashMatch) {
    const [, first, second, year, hour, minute] = slashMatch;
    const firstNumber = Number(first);
    const secondNumber = Number(second);

    if (firstNumber <= 12 && secondNumber > 12) {
      return hour !== undefined
        ? formatParts(year, firstNumber, secondNumber, hour, minute)
        : formatParts(year, firstNumber, secondNumber);
    }

    return trimmed;
  }

  return value;
}

export function normalizeDateForExport(value) {
  const formatted = formatDateToBrazil(value);

  return formatted === value ? value : formatted;
}
